export default "__VITE_ASSET__3af658c2__"